module.exports = __webpack_public_path__ + "img/red_delete.873b94f7.svg";